<template>
  <v-row justify="center">
    <v-dialog
      :value="open"
      @click:outside="closeDialog()"
      scrollable
      max-width="500"
    >
      <v-card>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
          rounded
          height="6"
        ></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Buscar Tickets
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true }
          }"
        >
          <v-card-text style="max-height: 400px">
            <v-form>
              <v-row dense justify="center">
                <!-- Numero -->
                <v-col cols="12">
                  <v-text-field
                    v-model="phoneNumber"
                    prepend-inner-icon="mdi-phone"
                    required
                    filled
                    rounded
                    dense
                    clearable
                    class="rounded-small"
                    name="phone"
                    label="Numero"
                    :disabled="module === 'chat'"
                  ></v-text-field>
                </v-col>

                <!-- Date -->
                <v-col cols="12">
                  <v-menu
                    ref="dateRangeMenu"
                    v-model="dateRangeMenu"
                    :close-on-content-click="false"
                    :return-value.sync="dates"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dates"
                        filled
                        rounded
                        class="rounded-small"
                        label="Rango de fecha"
                        prepend-inner-icon="mdi-calendar"
                        clearable
                        readonly
                        v-on="on"
                        @click:clear="dates = []"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="es-us"
                      v-model="dates"
                      :max="new Date().toISOString().substr(0, 10)"
                      range
                      scrollable
                      no-title
                    >
                      <v-spacer></v-spacer>
                      <v-hover v-slot:default="{ hover }">
                        <v-btn
                          text
                          rounded
                          class="mr-1"
                          :color="hover ? 'error' : 'grey'"
                          @click="dateRangeMenu = false"
                        >
                          Cancelar
                        </v-btn>
                      </v-hover>

                      <v-hover v-slot:default="{ hover }">
                        <v-btn
                          rounded
                          :loading="isLoading"
                          :disabled="isLoading"
                          color="success"
                          :class="hover ? 'shadow-2' : 'shadow-4'"
                          class="px-8"
                          @click="$refs.dateRangeMenu.save(dates)"
                        >
                          ok
                        </v-btn>
                      </v-hover>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Cola -->
                <v-col cols="12">
                  <v-select
                    v-model="searchData.queue_id"
                    prepend-inner-icon="mdi-tray-full"
                    required
                    filled
                    rounded
                    dense
                    clearable
                    class="rounded-small"
                    item-text="name"
                    item-value="id"
                    :items="queueList"
                    label="Cola"
                  ></v-select>
                </v-col>

                <!-- Agentes -->
                <v-col cols="12">
                  <v-select
                    v-model="searchData.agent"
                    prepend-inner-icon="mdi-account"
                    required
                    filled
                    rounded
                    dense
                    clearable
                    class="rounded-small"
                    item-text="name"
                    item-value="id"
                    :items="agentList"
                    label="Agentes"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>
        <v-card-actions class="mx-2">
          <v-hover v-slot:default="{ hover }" v-show="dates.length == 2">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'info' : 'grey'"
              @click="downloadCsv"
            >
              Descargar
            </v-btn>
          </v-hover>
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              rounded
              class="mr-1"
              :color="hover ? 'error' : 'grey'"
              @click="closeDialog()"
            >
              Cancelar
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="submitForm"
            >
              Buscar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import { clearNullOrUndefined, initialSearchData } from "./utils";
import { capitalizeFirstWord } from "@/components/Utils/stringHelpers";
import CdrDownloadToCsv from "@/components/Utils/CdrDownloadCsv";

export default {
  components: { vuescroll },
  props: {
    open: {
      type: Boolean
    },
    module: {
      type: String
    },
    phoneNumber: {
      type: String
    }
  },

  watch: {
    dates: {
      handler(values) {
        if (!values) {
          this.searchData.start = "";
          this.searchData.end = "";
        }
        if (values[0]) this.searchData.start = values[0].replaceAll("-", "/");
        if (values[1]) this.searchData.end = values[1].replaceAll("-", "/");
      },
      deep: true
    }
  },

  data() {
    return {
      isLoading: false,
      isLoadingCampaign: true,
      dateRangeMenu: false,
      dates: [],
      queueList: [],
      agentList: [],
      searchData: { ...initialSearchData },
      queueToFilter: null
    };
  },

  created() {
    this.getQueues();
    this.getAgents();
  },

  methods: {
    async getQueues() {
      try {
        const { data } = await PbxHttpClient.get("/clients/index_whatsapp");
        // console.log("colas:", data);
        this.queueList = data.data.map((el) => ({
          ...el,
          name: `${capitalizeFirstWord(el.name)} - ${el.number}`
        }));
      } catch (err) {
        console.log(err);
      }
    },

    async getAgents() {
      try {
        const { data } = await PbxHttpClient.get("/clients/show/agents_select");
        this.agentList = data.data;
      } catch (err) {
        console.log(err);
      }
    },

    closeDialog(clearFilters = true) {
      if (clearFilters) this.searchData = initialSearchData;
      this.$emit("dialog:close");
    },

    async submitForm() {
      this.searchData.number = this.phoneNumber;
      const filters = clearNullOrUndefined(this.searchData);
      this.closeDialog(false);
      this.$emit("dialog:submit", filters);
    },

    async downloadCsv() {
      this.isLoading = true;

      const payload = {
        type: "CDR WhatsApp",
        payload: {
          date_in: this.dates[0],
          date_end: this.dates[1]
        }
      };

      try {
        await CdrDownloadToCsv(payload, "cdrWhatsapp");

        this.isLoading = false;
        // this.activeDateModal = false;
      } catch (err) {
        // console.log(err);
        this.$snotify.error(
          "No se pudo descargar los registros seleccionados.",
          "¡Error!"
        );
      }
    }
  }
};
</script>

<style></style>
